import Vue from 'vue'
import Vuex from 'vuex'
import persistedState from 'vuex-persistedstate'
import * as Cookies from 'js-cookie'
import * as api from '../utils/api';
Vue.use(Vuex)

const store = new Vuex.Store({
  plugins: [
    // persistedState({ storage: window.sessionStorage }),
    persistedState({
      storage: {
        getItem: key => Cookies.get(key),
        setItem: (key, value) => Cookies.set(key, value, { expires: 7 }),     //登陆有效期7天
        removeItem: key => Cookies.remove(key)
      }
    })
  ],
  // 存储全局变量的数据 【单例状态】
  state: {
    authToken:null,   //token
    userInfo:{},    //用户详情

    user_type: {},
    article_type: {},
    user_title: {}
  },
  // 提供用来获取state数据的方法
  getters: {
    
  },
  // 提供存储设置state数据的方法【只能通过该方法修改】
  mutations: {
    //设置token
    setAuthToken(state,token){
      state.authToken = token;
    },
    // 设置用户信息
    setUserInfo(state,user){
      state.userInfo = user;
    },
    // 退出登录
    logout (state) {
      state.authToken = null
      state.userInfo = {}
    },

    //注入系统字典
    setSysData(state,data){
      state.user_type = data.user_type;
      state.article_type = data.article_type;
      state.user_title = data.user_title;
    }
  },
  // 提供跟后台接口打交道的方法，并调用mutations提供的方法
  actions: {
    // 刷新用户信息
    refreshUser(content){
      console.log('刷新用户');
      api.loginUserDetail().then(res=>{
        var uf = res.data;
        if(uf.competent){
          uf.competent = JSON.parse(uf.competent)
        }else{
          uf.competent = [];
        }
        content.commit('setUserInfo',uf);
      })
    },
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js